import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import Slider from 'react-slick';
import Col from 'reactstrap/lib/Col';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Button from './Button';

const InstaPosts = ({ posts, translate }) => {
  return (
    <>
      {posts && (
        <div className="section mt-1 px-3">
          <Container>
            <h2 className="title mb-3">
              <Translate id="index.latest-instagram" />
            </h2>
            <Slider
              appendDots={() => <span />}
              autoplay
              lazyLoad
              infinite
              speed={500}
              slidesToShow={4}
              slidesToScroll={1}
              arrows={false}
              responsive={[
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]}
            >
              {posts.map((i) => (
                <a key={i.shortcode} href={i.href} target="_blank" rel="noopener noreferrer">
                  <img
                    alt={`Instagram ${i.shortcode}`}
                    loading="lazy"
                    className="img-responsive"
                    src={i.image}
                    style={{
                      width: 'auto',
                      height: '200px',
                      borderRadius: '1rem',
                      border: '2pt solid #fff'
                    }}
                  />
                </a>
              ))}
            </Slider>
            <Row>
              <Col className="d-flex justify-content-end">
                <Button text={translate('index.follow-instagram')} externalLink="https://www.instagram.com/golfamore/" />
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default withLocalize(InstaPosts);
